export default __webpack_public_path__ + "static/media/logo-nobackground-1000.9322ef3a.png";